// @flow

/**
 * @module Constants/ApplePay
 * @desc ApplePay Constants
 */

import keyMirror from 'keymirror';

/**
 * @constant {Object} ApplePayConstants
 * @memberof ApplePay
 */
export const ApplePayConstants = keyMirror({
  VALIDATE_MERCHANT: undefined,
  SEND_QUICKPAY_TEXT: undefined,
});
